import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";

import { LinkHeap } from "@app/components";
import { HEAP_EVENTS } from "@app/provider/types";

import "./forgotEmail.scss";

const messages = defineMessages({
  forgotEmail: {
    id: "oneTimeCodeForgotEmail",
    defaultMessage: "Forgot email?",
  },
});

export interface ForgotEmailProps {
  url: string;
}

export const ForgotEmail: FC<ForgotEmailProps> = ({ url }) => {
  const intl = useIntl();

  return (
    <div className="forgot-email">
      <LinkHeap
        to={url}
        target="_blank"
        rel="noopener noreferrer"
        className="forgot-email__link"
        heapEventName={HEAP_EVENTS.upp_core_forgot_email_click}
      >
        {intl.formatMessage(messages.forgotEmail)}
      </LinkHeap>
    </div>
  );
};
